<!--
Copyright 2025 Google LLC. This software is provided as-is, without warranty 
or representation for any use or purpose. Your use of it is subject to your 
agreement with Google.
-->
<app-preview-citation [selectedCitation]="dialogData.citationContent" [previewPanelError]='dialogData.previewPanelError' [isMobileView]='dialogData.isMobileView' (closePreviewSection)="closePreviewSection($event)" >
</app-preview-citation>